<template>
  <div
    class="w-full flex items-center"
    :class="{ 'bg-primary5': isSelected }"
    :style="{ borderBottom: `1px solid transparent` }"
  >
    <div class="flex items-center w-full">
      <NCheckbox
        :checked="selectedItems.some((i) => i.id === item.id)"
        class="h-9 w-9 inline-flex items-center justify-center cursor-pointer mx-[5px]"
        :value="item.id"
      />

      <div class="flex items-start gap-2 py-4 pr-4 b-rounded-2">
        <CImage
          :ai-img-description="item.name"
          class="rounded-2 overflow-hidden"
          :height="100"
          :img-props="{}"
          lazy
          object-fit="cover"
          preview-disabled
          :src="data[index].thumbnail_url ?? data[index].metadata?.thumbnail"
          :style="{
            border: `1px solid ${themeVars.primary6}`,
          }"
          :width="100"
        />

        <div class="flex flex-wrap flex-col gap-3">
          <div class="flex flex-wrap font-700 font-size-[18px] overflow-hidden whitespace-normal break-words">
            {{ item.name }}
          </div>
          <div class="flex flex-wrap gap-2">
            <NTag
              v-for="tag in data[index].tags?.filter?.(
                (t) => !HIDE_TAGS_WITH_PREFIX.some((prefix) => t.startsWith(prefix)),
              )"
              :key="tag"
              class="rounded-xl bg-primary6"
              size="small"
              :style="{
                '--n-border': 'none',
                '--n-text-color': themeVars.text,
              }"
            >
              {{ tag }}
            </NTag>
          </div>
          <CPopularityAndEngagementExtended
            v-if="Object.keys(popularityDict)?.length && !hidePopularityIcons"
            class="gap-2 mr-2"
            :engagement="launchDarkly.show_popularity_icons ? popularityDict[data[index].id]?.engagement : undefined"
            :is-recommended="!!recommendedSectionIds.includes(data[index].id)"
            :popularity="launchDarkly.show_popularity_icons ? popularityDict[data[index].id]?.popularity : undefined"
            :views="launchDarkly.show_popularity_icons ? (popularityDict[data[index].id]?.views ?? 0) : 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { NCheckbox, NTag } from 'naive-ui'
import { computed, inject, type ComputedRef } from 'vue'

import CImage from '@lib/components/CImage/CImage.vue'
import CPopularityAndEngagementExtended from '@lib/components/CPopularityAndEngagementIcons/CPopularityAndEngagementExtended.vue'
import useRecommendations from '@canvas-builder/composables/useRecommendations'
import useSectionPopularity from '@canvas-builder/composables/useSectionPopularity'
import useThemeVars from '@lib/composables/useThemeVars'
import { HIDE_TAGS_WITH_PREFIX } from '@lib/constants/conventions.const'
import type { Canvas } from '@openapi'
import type { LaunchDarklyEnv } from '@lib/types/launchDarkly.types'

const props = withDefaults(
  defineProps<{
    filters: Record<string, any>
    isSelected?: boolean
    index?: number
    item: { id: number | string; [key: string]: any }
    data: Canvas[]
    selectedItems: Canvas[]
    hidePopularityIcons?: boolean
  }>(),
  {
    index: 0,
    isSelected: false,
    hidePopularityIcons: false,
  },
)

const launchDarkly = inject<ComputedRef<LaunchDarklyEnv>>(
  'launchDarkly',
  computed(() => ({})),
)

const themeVars = useThemeVars()
const filters = computed(() => props.filters)

const { popularityDict } = useSectionPopularity(filters)
const { recommendedSectionIds } = useRecommendations()
</script>
